import { AppConfig } from '../config/AppConfig';
import { TextoErrores } from '../config/TextoErrores';
import { CifradoUtils } from './CifradoUtils';
import { CodificadorJWT } from './CodificadorJWT';

export class DecodificadorJWT {

	codificador = new CodificadorJWT();

	private urlBase64Decode(str: string) {
		let output = str.replace(/-/g, '+').replace(/_/g, '/');
		switch (output.length % 4) {
			case 0: { break; }
			case 2: { output += '=='; break; }
			case 3: { output += '='; break; }
			default: {
				throw new Error(TextoErrores.ERROR_BASE64);
			}
		}
		return decodeURIComponent((window.atob(output)));
	}

    /**
     * 
     * @param token 
     */
	public decodeToken(token: string, esPeticionWeb: boolean, valueAes:string) {
		const parts = token.split('.');
		if (parts.length !== 3) {
			throw new Error(TextoErrores.ERROR_ESTRUCTURA_JWT);
		}
		let decoded;

		if (esPeticionWeb === true)
			decoded = this.urlBase64Decode(parts[1]);
		else
			decoded = CifradoUtils.b64DecodeUnicode(parts[1]);

		if (!decoded) {
			throw new Error(TextoErrores.ERROR_DECODIFICA_JWT);
		}

		const payloadDecoded = JSON.parse(decoded);
		const claveApp = this.codificador.encriptarKey(parts[0], parts[1], valueAes);
		const claveCallback = parts[2];

		if (claveCallback === claveApp) {

			if (AppConfig.VALIDAR_JWT) {
				if (!this.validateExpirationToken(payloadDecoded.exp)) {
					return { error: 'Ha ocurrido un error' };
				} else {
					return payloadDecoded;
				}
			}
			else {
				return payloadDecoded;
			}
		}
		else {			
			return { error: 'Ha ocurrido un error' };
		}
	}

    /**
     * Metodo para validar la expiracion del JWT
     * @param exp Fecha a validar
     */
	private validateExpirationToken(exp) {

		const now = new Date();
		const expiracion = new Date(exp * 1000);

		if (expiracion.getTime() <= now.getTime()) {
			return true;
		}
		else {
			return false;
		}
	}
}
